import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import * as AddClosingDayActions from 'web-app/react/closing-days/actions';

import * as Actions from './actions';

const hideModalOnCreate = action$ =>
    action$
        .ofType(AddClosingDayActions.addClosingDaysSuccess.type)
        .mergeMap(() => Observable.of(Actions.hide.action()));

export default combineEpics(hideModalOnCreate);
